import { lazy } from "react";
import AuthLock from "./handler/auth-lock";
import { Navigate } from "react-router-dom";
import CMSDetails from "../pages/cms-pages/details";
import FaqDetails from "../pages/faq/details";
const Main = lazy(() => import("../components/layout/main"));
// const Dashboard = lazy(() => import("../pages/dashboard"));
const Profile = lazy(() => import("../pages/profile"));
const ChangePassword = lazy(() => import("../pages/change-password"));
const UsersList = lazy(() => import("../pages/users/list"));
const AddEditUser = lazy(() => import("../pages/users/add-edit"));
const StoreAdminList = lazy(() => import("../pages/store-admin/list"));
const AddEditStore = lazy(() => import("../pages/store-admin/add-edit"));
const StoresList = lazy(() => import("../pages/stores/list"));
const AddEditStores = lazy(() => import("../pages/stores/add-edit"));
const StoresDetails = lazy(() => import("../pages/stores/details"));
const SocketProvider = lazy(
  () => import("../components/socket/SocketProvider"),
);

const PttChannelsList = lazy(() => import("../pages/ptt-channels/list"));
// const PttChannelsList = lazy(() => import("../pages/ptt-channels/list/list"));
const AddEditPttChannels = lazy(() => import("../pages/ptt-channels/add-edit"));
const PttChannelsDetails = lazy(() => import("../pages/ptt-channels/details"));
const DepartmentsList = lazy(() => import("../pages/departments/list"));
const AddEditDepartments = lazy(() => import("../pages/departments/add-edit"));
const DepartmentsDetails = lazy(() => import("../pages/departments/details"));

const AlertsList = lazy(() => import("../pages/alerts/list"));
const AlertsDetails = lazy(() => import("../pages/alerts/details"));

const CMSList = lazy(() => import("../pages/cms-pages/list"));
const AddEditCMS = lazy(() => import("../pages/cms-pages/add-edit"));

const FaqList = lazy(() => import("../pages/faq/list"));
const AddEditFaq = lazy(() => import("../pages/faq/add-edit"));

const ContactQueryList = lazy(() => import("../pages/contact-query/list"));
const ContactQueryDetail = lazy(() => import("../pages/contact-query/details"));
const Settings = lazy(() => import("../pages/settings"));

const protectRoutes = [
  {
    path: "",
    element: (
      <AuthLock>
        <Main />
      </AuthLock>
    ),
    children: [
      {
        path: "dashboard",
        index: true,
        element: (
          <AuthLock>
            {/* // TODO: Change once dashboard layout is received from client
            <Dashboard />
            */}
            <Navigate to={"/ptt-channels"} replace />
          </AuthLock>
        ),
      },
      {
        path: "my-profile",
        element: (
          <AuthLock>
            <Profile />
          </AuthLock>
        ),
      },
      {
        path: "change-password",
        element: (
          <AuthLock>
            <ChangePassword />
          </AuthLock>
        ),
      },
      {
        path: "settings",
        element: (
          <AuthLock adminOnly>
            <Settings />
          </AuthLock>
        ),
      },
      {
        path: "users",
        children: [
          {
            path: "",
            index: true,
            element: (
              <AuthLock>
                <UsersList />
              </AuthLock>
            ),
          },
          {
            path: "add",
            element: (
              <AuthLock>
                <AddEditUser />
              </AuthLock>
            ),
          },
          {
            path: "edit/:id",
            element: (
              <AuthLock>
                <AddEditUser />
              </AuthLock>
            ),
          },
        ],
      },
      {
        path: "store-admin",
        children: [
          {
            path: "",
            index: true,
            element: (
              <AuthLock>
                <StoreAdminList />
              </AuthLock>
            ),
          },
          {
            path: "add",
            element: (
              <AuthLock>
                <AddEditStore />
              </AuthLock>
            ),
          },
          {
            path: "edit/:id",
            element: (
              <AuthLock>
                <AddEditStore />
              </AuthLock>
            ),
          },
        ],
      },
      {
        path: "stores",
        children: [
          {
            path: "",
            index: true,
            element: (
              <AuthLock adminOnly>
                <StoresList />
              </AuthLock>
            ),
          },
          {
            path: "add",
            element: (
              <AuthLock adminOnly>
                <AddEditStores />
              </AuthLock>
            ),
          },
          {
            path: "edit/:id",
            element: (
              <AuthLock adminOnly>
                <AddEditStores />
              </AuthLock>
            ),
          },
          {
            path: "details/:id",
            element: (
              <AuthLock adminOnly>
                <StoresDetails />
              </AuthLock>
            ),
          },
        ],
      },
      {
        path: "ptt-channels",
        children: [
          {
            path: "",
            index: true,
            element: (
              <AuthLock>
                <SocketProvider>
                  <PttChannelsList />
                </SocketProvider>
              </AuthLock>
            ),
          },
          {
            path: "add",
            element: (
              <AuthLock>
                <AddEditPttChannels />
              </AuthLock>
            ),
          },
          {
            path: "edit/:id",
            element: (
              <AuthLock>
                <AddEditPttChannels />
              </AuthLock>
            ),
          },
          {
            path: "details/:id",
            element: (
              <AuthLock>
                <PttChannelsDetails />
              </AuthLock>
            ),
          },
        ],
      },
      {
        path: "departments",
        children: [
          {
            path: "",
            index: true,
            element: (
              <AuthLock>
                <DepartmentsList />
              </AuthLock>
            ),
          },
          {
            path: "add",
            element: (
              <AuthLock>
                <AddEditDepartments />
              </AuthLock>
            ),
          },
          {
            path: "edit/:id",
            element: (
              <AuthLock>
                <AddEditDepartments />
              </AuthLock>
            ),
          },
          {
            path: "details/:id",
            element: (
              <AuthLock>
                <SocketProvider>
                  <DepartmentsDetails />
                </SocketProvider>
              </AuthLock>
            ),
          },
        ],
      },
      {
        path: "alerts",
        children: [
          {
            path: "",
            index: true,
            element: (
              <AuthLock>
                <AlertsList />
              </AuthLock>
            ),
          },
          {
            path: "details/:id",
            element: (
              <AuthLock>
                <AlertsDetails />
              </AuthLock>
            ),
          },
        ],
      },
      {
        path: "cms-pages",
        children: [
          {
            path: "",
            index: true,
            element: (
              <AuthLock>
                <CMSList />
              </AuthLock>
            ),
          },
          {
            path: "add",
            element: (
              <AuthLock>
                <AddEditCMS />
              </AuthLock>
            ),
          },
          {
            path: "edit/:id",
            element: (
              <AuthLock>
                <AddEditCMS />
              </AuthLock>
            ),
          },
          {
            path: "details/:id",
            element: (
              <AuthLock>
                <CMSDetails />
              </AuthLock>
            ),
          },
        ],
      },
      {
        path: "faqs",
        children: [
          {
            path: "",
            index: true,
            element: (
              <AuthLock>
                <FaqList />
              </AuthLock>
            ),
          },
          {
            path: "add",
            element: (
              <AuthLock>
                <AddEditFaq />
              </AuthLock>
            ),
          },
          {
            path: "edit/:id",
            element: (
              <AuthLock>
                <AddEditFaq />
              </AuthLock>
            ),
          },
          {
            path: "details/:id",
            element: (
              <AuthLock>
                <FaqDetails />
              </AuthLock>
            ),
          },
        ],
      },
      {
        path: "contact-queries",
        children: [
          {
            path: "",
            index: true,
            element: (
              <AuthLock>
                <ContactQueryList />
              </AuthLock>
            ),
          },
          {
            path: "details/:id",
            element: (
              <AuthLock>
                <ContactQueryDetail />
              </AuthLock>
            ),
          },
        ],
      },
    ],
  },
];

export default protectRoutes;
